/* pantallas-alumno (B): LAS PESTANAS DE DOS BOTONES (el control E1 del Panel).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Fondo #111111, borde #222222, radio 12 y 4 de aire; el elegido en blanco con texto negro, los demas
   #9A9A9A. Es la MISMA forma que las pestanas "Active" y "Locked" del Panel (Dashboard.js), aqui como
   pieza. Dos variantes:
   - `pestanas` (las del detalle de Analiticas): 40 en computadora, 44 en el celular, a lo ancho, cada
     mitad del mismo ancho; en el celular sin iconos y a 13 px. Es una lista de pestanas (tablist).
     En el celular el texto no se corta: si no cabe en un renglon parte en dos dentro de sus 44
     (renglon de 16, relleno de 6 a los lados); desde 768, un renglon con "..." como antes (cotejo con
     el PDF, AN3 y vecinas en 390).
   - `idioma` (Ajustes): "EN" y "ES", 36 en computadora y 44 en el celular. Es una eleccion unica
     (radiogroup).
   `aLoAncho` (por omision, verdadero) hace que el control ocupe toda la fila. */
import React from 'react';

const ALTO = {
  pestanas: 'min-h-[44px] md:min-h-[40px]',
  idioma: 'min-h-[44px] md:min-h-[36px]',
};

export default function PestanasDeDosBotones({
  opciones = [], valor, onCambio, etiqueta, variante = 'pestanas', aLoAncho = true, testid, className = '',
}) {
  const esIdioma = variante === 'idioma';
  const alto = ALTO[variante] || ALTO.pestanas;
  const relleno = esIdioma ? 'px-3' : 'max-md:px-1.5 md:px-3';
  const claseDelTexto = esIdioma ? 'truncate' : 'min-w-0 max-md:leading-4 max-md:text-center md:truncate';
  return (
    <div
      role={esIdioma ? 'radiogroup' : 'tablist'}
      aria-label={etiqueta}
      data-testid={testid}
      className={`${aLoAncho ? 'flex w-full' : 'inline-flex'} items-center gap-1 p-1 bg-[#111111] border border-[#222222] rounded-xl ${className}`.trim()}
    >
      {opciones.map((op) => {
        const elegido = op.valor === valor;
        const Icono = op.icono;
        return (
          <button
            key={op.valor}
            type="button"
            role={esIdioma ? 'radio' : 'tab'}
            aria-selected={esIdioma ? undefined : elegido}
            aria-checked={esIdioma ? elegido : undefined}
            onClick={() => { if (!elegido && onCambio) onCambio(op.valor); }}
            data-testid={op.testid}
            className={`flex-1 basis-0 min-w-0 flex items-center justify-center gap-1.5 ${relleno} ${alto} rounded-lg text-[13px] md:text-[14px] font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${elegido ? 'bg-white text-black' : 'text-[#9A9A9A] hoverable:text-white'}`}
          >
            {Icono ? <Icono className="w-4 h-4 shrink-0 max-md:hidden" aria-hidden="true" /> : null}
            <span className={claseDelTexto}>{op.texto}</span>
          </button>
        );
      })}
    </div>
  );
}
